import { NtfHeroClassType } from 'src/utils/types';
import icMarksman from 'assets/svg/ic_hrc_marksman.svg';
import icAssassin from 'assets/svg/ic_hrc_assassin.svg';
import icTank from 'assets/svg/ic_hrc_tank.svg';
export const colorMap = {
  [NtfHeroClassType.TANK]: {
    displayValue: 'TANK',
    icon: icTank
  },
  [NtfHeroClassType.MARKSMAN]: {
    displayValue: 'MARKSMAN',
    icon: icMarksman
  },
  [NtfHeroClassType.ASSASSIN]: {
    displayValue: 'ASSASSIN',
    icon: icAssassin
  }
};